// ============================================================================
// Anaglyphic, Amsterdam 2023, All Rights Reserved.
// See README in the root project for more information.
// ============================================================================

import { ToastOptions, ToastType, useToastStore } from "@/stores/toast";

/**
 * Composable for using toast notifications throughout the application
 */
export default function useToast() {
	const toastStore = useToastStore();

	return {
		info: (message: string, options?: ToastOptions) =>
			toastStore.info(message, options),
		warning: (message: string, options?: ToastOptions) =>
			toastStore.warning(message, options),
		error: (message: string, options?: ToastOptions) =>
			toastStore.error(message, options),
		loading: (message: string, options?: ToastOptions) =>
			toastStore.loading(message, options),
		success: (message: string, options?: Partial<ToastOptions>) =>
			toastStore.success(message, options),
		dismiss: (id) => toastStore.remove(id),
		dismissAll: (typesToDismiss?: ToastType | ToastType[]) =>
			toastStore.clear(typesToDismiss),
	};
}
